// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 12,
  argument: "A prayer in tribulation.",
  verses: [
    { n: 1, text: "Unto the end, a psalm for David. How long, O Lord, wilt thou forget me unto the end? how long dost thou turn away thy face from me?" },
    { n: 2, text: "How long shall I take counsels in my soul, sorrow in my heart all the day?" },
    { n: 3, text: "How long shall my enemy be exalted over me?" },
    { n: 4, text: "Consider, and hear me, O Lord, my God. Enlighten my eyes, that I never sleep in death:" },
    { n: 5, text: "Lest at any time my enemy say: I have prevailed against him. They that trouble me, will rejoice when I am moved:" },
    { n: 6, text: "But I have trusted in thy mercy. My heart shall rejoice in thy salvation: I will sing to the Lord, who giveth me good things: yea, I will sing to the name of the Lord, the most high." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Me? These expressions are figurative. God seems displeased: but it is often for our greater good. Some explain this of David, Ezechias, the captives, &c. It may be applied to every afflicted soul, which places her whole trust in God.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "Day; frequently. (Worthington) — Septuagint adds, \"and night.\" (Calmet) — These cares and perplexities arise from persecutions and from man's weakness.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Enemy; Saul, &c., or the devil. (St. Augustine)", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "Death, by mortal sin, (Worthington) or through excessive sorrow, Jeremias li. 39. Shew me thy favour, (Calmet) and I shall be secure. Sleep is represented as nearly related to death. (Homer, Iliad xiv.) Tum consanguineus lethi sopor. (Virgil, �neid vi.)", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Mercy. Man must attribute nothing to himself, otherwise he will be moved by pride. (St. Augustine) (Calmet) — Things; patience and reward. (Worthington) — The prophet feels a secret confidence arising in his breast, in consequence of God's protection. — Yea, &c., is not in Hebrew but it is in the Septuagint, Arabic, and the ancient Fathers. Hebrew, \"My heart shall be transported in thy salvation; I will praise the Lord, because he has rendered me the like,\" as I placed my hopes in him: (Calmet) or, \"he hath rewarded me.\" The blessed Mary adopts the language of this verse, [Luke i. 46-55] and the prophet probably had the same salvation, Christ, in view.", attribution: "Berthier" }
    ] },
  ],
};

export default chapter;
